import type { ColumnDef, RadarMapping } from '@deckspace/types';
import { rowsToColumnar, getColumn, defsByName, type Series } from '../shared/pivot.js';

export interface RadarResult {
  labels: string[];
  datasets: Series[];
}

export function prepRadarSeries(
  rows: Record<string, unknown>[],
  columnDefs: ColumnDef[],
  mapping: RadarMapping
): RadarResult {
  const tableData = rowsToColumnar(rows);
  const defs = defsByName(columnDefs);
  const labels = getColumn<string>(tableData, mapping.labels).map(String);
  const valuesCol = mapping.values;
  return {
    labels,
    datasets: [
      {
        label: valuesCol,
        values: getColumn<number>(tableData, valuesCol).map((v) => Number(v) || 0),
        type: defs[valuesCol]?.type ?? 'number',
        unit: defs[valuesCol]?.unit,
        currency: defs[valuesCol]?.currency,
      },
    ],
  };
}
